import React from "react";
import {REDIRECT_TIMEOUT} from "../../Constants/AppData";
import styled from "styled-components";
import {WerfenFormTextColor} from "../../Constants/ColorChart";

const StyledParagraph = styled.p`
  border: none;
  width: 100%;
  color: ${WerfenFormTextColor};
  padding-left: 5%;
  padding-right: 5%;
  display: inline-block;
  padding-bottom: 2%;
  margin-right: 0;
  font-size: 15px;
`;

const LoginRedirect: React.FC<{}> = () => {
    const seconds = REDIRECT_TIMEOUT / 1000;

    return (
        <div>
            <StyledParagraph>
                You need to start your session from the following link:
                <br/>
                <br/>
                <a href={process.env.REACT_APP_REDIRECT_FOR_LOGIN}>
                    {process.env.REACT_APP_REDIRECT_FOR_LOGIN}
                </a>
                <br/>
                <br/>
                You'll be redirected automatically
                in {seconds} seconds...
            </StyledParagraph>
        </div>
    );
}

export default LoginRedirect;